<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbarFive class="home_one" />
  <PageBanner pageTitle="Portfolio" mainTitle="Portfolio" />
  <PortfolioContent />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbarFive from "../components/Layouts/ResponsiveNavbarFive.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import PortfolioContent from "../components/Portfolio/PortfolioContent.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "PortfolioPage",
  components: {
    NavbarFive,
    ResponsiveNavbarFive,
    PageBanner,
    PortfolioContent,
    DownloadTheApp,
    MainFooter,
  },
});
</script>